<template>
  <div class="department-wrap" ref="departmentWrap">
    <!-- 组织纯文本 -->
    <read-department v-if='isPureText' v-bind='{ ...$props }'></read-department>
    <!-- 树形tree -->
    <template v-else>
      <tree-selector
        v-if="style"
        v-on="$listeners"
        v-bind="treeProps"
        :selectedKeys="selectedKeys"
        :selectedIds="selectedKeys"
        :selectedData="selectedData"
        @change="treeChange"
        :load="handleLazyLoad"
        :remoteFilter="orgFilter"
        :props="orgProps"
        :height="height"
        :multiple="multiple"
        :filterable="filterable"
      />
      <!-- 级联 -->
      <cascade-selector
        v-else
        v-on="$listeners"
        v-bind="treeProps"
        :selectedKeys.sync="selectedKeys"
        :selectedIds="selectedKeys"
        :selectedData="selectedData"
        @change="treeChange"
        :load="handleLazyLoad"
        :remoteFilter="orgFilter"
        :props="orgProps"
        :height="height"
        :multiple="multiple"
        :filterable="filterable"
      />
    </template>
  </div>
</template>

<script>
  import response from '../../../utils/response.js'
  import cachedRequest from '../../../../../../utils/cached-request'
  import ReadDepartment from './components/read-department.vue'
  import TreeSelector from '../../../../../basis/tree-selector/index.vue'
  import CascadeSelector from '../../../../../basis/cascade-selector/index.vue'
  import projectInfo from '../../../utils/project-info'
  import {departmentProps} from './index.js'

  export default {
    name: 'department',
    components: {
      TreeSelector,
      CascadeSelector,
      ReadDepartment
    },
    props: departmentProps,
    model: {
      event: 'tree-change',
      prop: 'select'
    },
    computed: {
      treeProps () {
        return {
          placeholder: this.placeholder,
          'check-strictly': true,
          mustLeaf: false,
          lazy: true,
          width: this.treeWidth,
          ...this.$attrs,
          disabled: this.project || this.disabled
        }
      },
      height () {
        return this.$attrs.size === 'mini'
          ? '30'
          : '38'
      },
      orgProps () {
        return {
          key: this.valueKey || 'id',
          label: 'name',
          children: 'nodeTree',
          disabled: 'disabled',
          isLeaf: 'isLeaf'
        }
      },
      style () {
        return this.uiType === 'cascade'
      },
      project () {
        return projectInfo.include('sur')
      }
    },
    data () {
      return {
        selectedKeys: [],
        selectedData: [],
        firstOrgData: [],
        treeWidth: '',
        // cascade
        pagination: {
          page: 1,
          pageSize: 500
        },
        filterList: [],
        catchData: []
      }
    },
    watch: {
      select (value) {
        this.initSelected(value)
      }
    },
    mounted () {
      this.treeWidth = this.$refs['departmentWrap'].offsetWidth
      // 回显
      this.initSelected(this.select)
    },
    methods: {
      initSelected (value) {
        // 回显数据
        const type = Object.prototype.toString.call(value)
        const key = this.orgProps.key
        const typeMap = {
          '[object Array]': () => {
            if (typeof value[0] === 'object') {
              this.selectedData = value
              this.selectedKeys = value.map(v => v[key])
            } else {
              this.selectedHandle(value)
            }
          },
          '[object Object]': () => {
            this.selectedData = [value]
            this.selectedKeys = [value[key]]
          },
          '[object Undefined]': () => {
            this.selectedData = []
            this.selectedKeys = []
          },
          default: () => {
            if (value) {
              this.selectedHandle([value.toString()])
            } else {
              this.selectedData = []
              this.selectedKeys = []
            }
          }
        }

        typeMap[type] ? typeMap[type]() : typeMap['default']()
      },
      // 基本类型数据转换
      async selectedHandle (value) {
        const data = await this.departmentListByIds(value)
        const {key, label} = this.orgProps
        this.selectedKeys = value
        this.selectedData = data.map(v => {
          return {
            [key]: v[key],
            [label]: v.name
          }
        })
      },
      // tree change
      treeChange ({unInitSelectedKeys, simple}) {
        const {multiple} = this.treeProps
        const {key} = this.orgProps

        // 缓存选过的组织
        this.catchData.push(...simple)
        // 清空操作 不做处理
        if (!unInitSelectedKeys.length && !simple.length) {
          this.selectedKeys = []
          this.selectedData = []
          return this.$emit('tree-change', this.valueKey ? '' : {_update: true})
        }

        let selectData = simple
        // 判断是否为筛选的选中
        if (!simple.length && unInitSelectedKeys.length) {
          selectData = this.filterList.filter(v => unInitSelectedKeys.includes(v.key))
        }
        this.selectedKeys = selectData.map(v => v[key])

        // 添加默认数据
        selectData = multiple
          ? selectData.map(
            v =>
              this.valueKey
                ? v[key]
                : {
                  ...v,
                  _update: true
                }
          )
          : (this.valueKey ? selectData[0][key] : {...selectData[0], _update: true})

        this.$emit('tree-change', selectData)
      },
      // 请求下一级
      async handleLazyLoad (node, resolve) {
        // TODO tree-selector组件禁用状态单击输入框时也会触发load所以在这里处理一下
        if (this.treeProps.disabled) {
          return
        }

        const api = this.userApi.orgLazyLoadList
        let param = {}
        // 包含根组织
        if (this.hasRoot) {
          param = {
            'pid': node.level === 0 ? null : node.data.id
          }
        } else {
          param = {
            'pid': node.level === 0 ? null : node.data.id,
            'withRoot': 0
          }
        }
        if (node.level === 1 && this.hasRoot) {
          resolve(this.firstOrgData)
          return
        }
        const res = await cachedRequest(api, param)
        if (res.success && res.code === 'success') {
          let treeData = (res.content && res.content.orgTree) || []
          if (this.hasRoot && node.level === 0) {
          } else {
            treeData.map((item) => {
              this.$set(item, 'isLeaf', !item.hasChild)
            })
          }
          resolve(treeData)
          if (this.hasRoot && res.content && res.content.orgTree.length) {
            this.firstOrgData = res.content.orgTree[0].nodeTree
            this.firstOrgData.map((item) => {
              this.$set(item, 'isLeaf', !item.hasChild)
            })
          }
        }
      },
      // 筛选
      async orgFilter (queryString) {
        if (!this.treeProps.filterable || !queryString) {
          return []
        }
        let params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          name: queryString
        }
        let api = this.userApi.orgFilter
        if (this.mustLeaf) {
          params.isLeaf = this.treeProps.mustLeaf
        }
        let res = await response(
          {
            method: api.type,
            url: api.url,
            params: params
          }
        )
        if (res.isOk) {
          let nodes = res.content
          nodes = nodes.map(item => {
            return {
              key: item[this.orgProps.key],
              label: item.name,
              parentId: item.parentId,
              completeLabel: item.treeNames,
              code: item.code,
              names: item.treeNames,
              id: item.id,
              customCode: item.customCode
            }
          })
          this.filterList = nodes
          return nodes
        } else {
          return []
        }
      },
      async departmentListByIds (param) {
        const {type, url} = this.userApi.departmentListByIdsOrCodes
        const keyMap = {'id': 'ids', 'code': 'codes'}
        const {key} = this.orgProps
        const catchData = []
        const keys = JSON.parse(JSON.stringify(param || '{}'))

        // 查询缓存批量查询出缓存
        param.forEach(v => {
          this.catchData.forEach((k, i) => {
            if (k[key].toString() === v.toString()) {
              catchData.push(k)
              keys.splice(i, 1)
            }
          })
        })

        // 如果都在缓存内则不调用接口
        if (catchData.length === param.length) {
          return catchData
        }

        const params = {[keyMap[key]]: keys}
        const {isOk, content} = await response(
          {
            method: type,
            url: url,
            params: params
          }
        )

        if (isOk) {
          return (content || []).concat(catchData)
        }
      }
    }
  }
</script>

<style lang="scss">
  .el-form-item.is-error .el-form-item__content .department-wrap .el-input__inner {
    border: 1px solid #F5222D;
  }
</style>
